import { render, staticRenderFns } from "./messageItem.vue?vue&type=template&id=755c8c93&scoped=true"
import script from "./messageItem.vue?vue&type=script&lang=js"
export * from "./messageItem.vue?vue&type=script&lang=js"
import style0 from "./messageItem.vue?vue&type=style&index=0&id=755c8c93&prod&lang=scss&scoped=true"
import style1 from "./messageItem.vue?vue&type=style&index=1&id=755c8c93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755c8c93",
  null
  
)

export default component.exports